<template>
  <div class="people-position-page">
    <div class="innerBox">
      <iframe id="iframe" :src="url" style="width: 100%;height:98vh;border: 0px;margin:0;"></iframe>
    </div>
    <button class="sso-return-button" type="button" @click="backToSystem">
      <i class="el-icon-s-home"></i>
      返回系统
    </button>
  </div>
</template>

<script>
import url from "url";

export default {
  name: 'peoplePosition',
  data() {
    return {
      url:""
    }
  },
  created() {
    const companyInfo =JSON.parse(localStorage.getItem('companyInfo'));//TODO:获取租户公司信息
   // this.url = companyInfo.serviceIp+"screen?url=largescreen4&name="+companyInfo.serviceUserName+"&code="+companyInfo.serviceCode;
    this.url = companyInfo.serviceIp+"/autologin?url=screen&name="+companyInfo.serviceUserName+"&code="+companyInfo.serviceCode;
    this.$nextTick(() => {

    })
  },
  methods: {
    backToSystem() {
      this.$router.push('/processManager');
    }
  }
}
</script>

<style scoped>
.people-position-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.sso-return-button {
  position: fixed;
  top: 10px;
  left: 22px;
  z-index: 9999;
  min-width: 132px;
  height: 46px;
  padding: 0 20px;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  background: linear-gradient(90deg, rgba(4, 125, 198, .96), rgba(247, 151, 54, .96));
  clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
  box-shadow: 0 0 14px rgba(0, 210, 255, .55);
}

.sso-return-button:hover {
  filter: brightness(1.12);
}

.sso-return-button > i {
  margin-right: 6px;
}

.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
.innerBox {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 10px
}
.innerTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.innerTitle .screenBox {
  width: 45%;
  display: flex;
  justify-content: space-between;
}
.formBox /deep/ .el-form-item {
  margin-bottom: 10px
}
.formBox /deep/ .el-form-item__error {
  padding-top: 2px
}
</style>
